export default {
      id: "video-event_left-turn-usage",
      viewBox: "0 0 15 20",
      url: __webpack_public_path__ + "img/icons.svg#video-event_left-turn",
      toString: function () {
        return this.url;
      }
    }